var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('div',{on:{"drop":function($event){$event.stopPropagation();return _vm.onDrop.apply(null, arguments)},"dragover":function($event){$event.preventDefault();},"dragenter":function($event){$event.preventDefault();}}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }